import MealEntity from '../Entity/Meal';

const MealsForPostFilteringRepository = Backbone.Collection.extend({
    model: MealEntity,
});

const repository = new MealsForPostFilteringRepository([
    { id: 1, name: 'Всё включено', code: 'AI' },
    { id: 2, name: 'Завтрак', code: 'BB' },
    { id: 3, name: 'Завтрак, обед, ужин', code: 'FB' },
    { id: 5, name: 'Завтрак + ужин', code: 'HB' },
    { id: 7, name: 'Без питания', code: 'RO' },
    { id: 8, name: 'Ультра все включено', code: 'UAI' },
    { id: 10, name: 'Завтрак, обед', code: 'LHB' },
    { id: 11, name: 'Всё включено (без алкоголя)', code: 'AI(noAlc)' },
]);

MealsForPostFilteringRepository.repository = repository;

export default MealsForPostFilteringRepository;
